import styled from 'styled-components';
import { glassEffect } from '../../theme';

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.heading};
  margin-bottom: 30px;
`;

export const ScanButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-bottom: 20px;
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.navActiveBg};
  color: ${({ theme }) => theme.heading};
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.cardBorder};
  }
`;

export const DropzoneContainer = styled.div`
  ${glassEffect}
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
  transition: border-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const UploadButton = styled.button`
  margin-top: 20px;
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.cardBorder};
    cursor: not-allowed;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
`;

export const FilePreviewList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 20px;
  color: ${({ theme }) => theme.text};
`;

export const FilePreviewItem = styled.li`
  ${glassEffect}
  padding: 10px 15px;
  border-radius: 8px;
  margin-bottom: 8px;
`;